// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ooD8","placeholdersHeader":"styles_placeholdersHeader__UVvn6","editorStyle":"styles_editorStyle__1-17T","placeholdersBox":"styles_placeholdersBox__2_FsS"};